<template lang="pug">
	img(
		src="http://7xlsgk.com2.z0.glb.qiniucdn.com/2qi148025184379643.jpg"
		@click="click()"
	)
</template>
<script>
	const axios = require('axios').create()

	module.exports = {
		mounted () {
			axios.get('https://test.qiang7.cn/api/extra/ads/401efd5f4c223e18/splash')
		},
		methods: {
			click () {
				location.replace('https://test.qiang7.cn/api/extra/ads/e3222ff1fc776caf/splash/track')
			}
		}
	}
</script>



// WEBPACK FOOTER //
// b.vue?721c430e